import StateCardView from "components/base/StateCardView";
import ReviewStepView from "./ReviewStepView";

const SupplierReviewView = ({ supplierState, supplierReview }) => {
  const stepStates = JSON.parse(supplierReview.stepStates);

  const steps = supplierReview.review
    ? supplierReview.review.steps.map((s) => ({
        ...s,
        state: stepStates[parseInt(s.id)],
      }))
    : [];

  return (
    <StateCardView primary={supplierState === "PENDING"}>
      <h5>Review</h5>

      <div className="mt-2 -mx-2">
        <table>
          <tbody>
            {steps.map((step, index) => (
              <ReviewStepView
                supplierState={supplierState}
                isCurrentStep={
                  supplierReview.currentStep &&
                  step.id === supplierReview.currentStep.id
                }
                reviewId={supplierReview.review.id}
                step={step}
                index={index}
                key={step.id}
              />
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-xs mt-2">
        Once all review accepted, the supplier state will be updated
        automatically.
      </div>
    </StateCardView>
  );
};

export default SupplierReviewView;
